import classNames from 'classnames';
import { LightAlert } from 'components/shared/LightAlert';
import { FC, useMemo } from 'react';
import { useIntl } from 'react-intl';

import { useAppFeedbackConfiguration } from './useAppFeedbackConfiguration';

export const SurveyContainer: FC = () => {
  const [fetchStatus, config, onRetry] = useAppFeedbackConfiguration();

  const appFeedbackUrl = useMemo(() => {
    return config?.url;
  }, [config?.url]);

  const iframeHeight = useMemo<string>(() => {
    return Math.min((75 * window.innerHeight) / 100, 750) + 'px';
  }, []);

  return (
    <>
      {fetchStatus === 'success' && (
        <iframe
          data-e2e="app-feedback-iframe"
          src={appFeedbackUrl}
          width="100%"
          height={iframeHeight}
          style={{ border: 'none' }}
        ></iframe>
      )}
      {(fetchStatus === 'error' || fetchStatus === 'unauthorized') && <Error onRetry={onRetry} />}
    </>
  );
};

const Error: FC<{ className?: string; onRetry?: () => void }> = ({ className, onRetry }) => (
  <TechnicalError onRetry={onRetry || null} className={classNames('py-4 px-5', className)} />
);

interface TechnicalErrorProps {
  className?: string;

  e2e?: string;
  onRetry: Nullable<() => void>;
}
export const TechnicalError: FC<TechnicalErrorProps> = ({ e2e, onRetry, className }) => {
  const { formatMessage } = useIntl();
  return (
    <div className="w-100">
      <LightAlert severity="secondary" e2e={e2e} className={className}>
        <span className="flex-grow-1">
          {formatMessage({
            id: 'appFeedback.fetchData.error',
            defaultMessage: 'Technical error while fetching data',
          })}
        </span>
        {onRetry && (
          <button className="btn btn-sm btn-outline-secondary float-end" onClick={onRetry}>
            {formatMessage({
              id: 'appFeedback.fetchData.retry',
              defaultMessage: 'retry',
            })}
          </button>
        )}
      </LightAlert>
    </div>
  );
};
